import { PlusOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Button, message, Modal, Space, Table } from "antd";
import { AxiosResponse } from "axios";

import { FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PaginationEntity } from "../../common/entity/pagination.entity";
import { ResponseEntity } from "../../common/entity/response.entity";
import { CarBrandEntity } from "src/module/CarBrand/carBrand.entity";
import carBrandService from "src/module/CarBrand/carBrand.service";
import { checkPermission } from "src/module/admin/service/permission.service";

const { confirm } = Modal;
export const CarBrandList: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [paginationObj, setPaginationObj] = useState<PaginationEntity>({
		customPageSize: 15,
		customPageNum: 1,
		total: 0,
	});
	const [carBrandList, setCarBrandList] = useState<CarBrandEntity[]>([]);
	const [total, setTotal] = useState<number>(0);
	const [loading, setLoading] = useState(true);
	const init = useCallback(async () => {
		setLoading(true);
		const { data } = await carBrandService.list({ ...paginationObj });
		if (data.code === 200) {
			setCarBrandList(data.data);
			setTotal(data.total);
		}
		setLoading(false);
	}, [paginationObj]);

	useEffect(() => {
		init();
	}, [init]);

	const deleteBanner = (id: number) => {
		confirm({
			title: t("confirmOperation"),
			okText: "Yes",
			okType: "danger",
			cancelText: "No",
			onOk: async () => {
				const { data }: AxiosResponse<ResponseEntity> = await carBrandService.delete(id);
				if (data.code === 200) {
					message.success(data.msg);
					init();
				}
			},
			onCancel() {
				console.log("Cancel");
			},
		});
	};

	const columns = [
		{
			width: 180,
			title: t("logoImage"),
			dataIndex: "img",
			render: (text: string | undefined) => {
				return <img src={text} width='100' alt='' style={{ border: "1px solid #e1e1e1" }} />;
			},
		},
		{
			width: 180,
			title: t("letter"),
			dataIndex: "letter",
		},
		{
			title: t("brandName"),
			dataIndex: "name",
		},

		{
			title: t("action"),
			render: (text: string, record: CarBrandEntity) => {
				return (
					<Space>
						{checkPermission(80302)&&
							<Button
								type='default'
								onClick={() => {
									navigate(`/carBrand/detail/${record.id}`);
								}}
							>
								{t("edit")}
							</Button>
						}
						{checkPermission(80303)&&
							<Button
								type='primary'
								danger
								onClick={() => {
									deleteBanner(record.id ?? 0);
								}}
							>
								{t("delete")}
							</Button>
						}
					</Space>
				);
			},
		},
	];
	return (
		<Container>
			{checkPermission(80302)&&
			<Button type={"primary"} icon={<PlusOutlined />} onClick={() => navigate(`/carBrand/detail`)}>
				{t("addCarBrand")}
			</Button>}

			<Table
				columns={columns}
				loading={loading}
				dataSource={carBrandList}
				pagination={{
					pageSize: paginationObj.customPageSize,
					current: paginationObj.customPageNum,
					total: total,
					showTotal: () => {
						return (
							<div>
								{t("total")} {total}
							</div>
						);
					},
				}}
				style={{ width: "100%" }}
				rowKey={(record) => record.id + ""}
				onChange={(pagination) => {
					setPaginationObj({
						...paginationObj,
						customPageNum: pagination.current,
						customPageSize: pagination.pageSize,
					});
					setPaginationObj({
						...paginationObj,
						customPageNum: pagination.current ?? 1,
						customPageSize: pagination.pageSize ?? 15,
					});
				}}
			/>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
	padding: 10px;
	.headers {
		width: 100%;
		.searchList {
			width: 100%;
			display: flex;
			align-items: center;
			margin-bottom: 15px;
			.searchItem {
				min-width: 150px;
				text-align: right;
			}
		}
	}
`;
